import { Stack } from '@mui/material'
import { categories } from '../utils/constants'

const Sidebar = ({ selectedCategory, setSelectedCategory }) => (
  <Stack 
    direction='row'
    sx={{ 
      overflowY: 'auto',
      height: { sx: 'auto', md: '95%' },
      flexDirection: { md: 'column' },
    }}
  >
    {categories.map((category) => (
      <button
        className='category-btn'
        onClick={() => setSelectedCategory(category.name)}
        style={{
          background: category.name === selectedCategory && '#007579',
          color: '#fff'
        }}
        key={category.name}
      >
        <span style={{ color: category.name === selectedCategory ? 'white' : '#007579', marginRight: '15px', marginBottom: '-3px' }}>{category.icon}</span>
        <span style={{ opacity: category.name === selectedCategory ? '1' : '0.8' }}>{category.name}</span>
      </button>
    ))}
  </Stack>
)

export default Sidebar